import { Capacitor } from '@capacitor/core';

export type BackendRole = 'profesor' | 'elev' | 'parinte' | 'admin' | string;

export const TOKEN_KEY = 'token';

function isNativeApp(): boolean {
  try {
    if (typeof Capacitor?.isNativePlatform === 'function') return Capacitor.isNativePlatform();
    if (typeof Capacitor?.getPlatform === 'function') return Capacitor.getPlatform() !== 'web';
    return false;
  } catch {
    return false;
  }
}

export function getToken(): string | null {
  if (isNativeApp()) return localStorage.getItem(TOKEN_KEY);
  return sessionStorage.getItem(TOKEN_KEY) ?? localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string, remember: boolean): void {
  // In the native (Capacitor) app, sessionStorage is lost when the app process is killed,
  // which feels like a forced logout. Persist tokens in localStorage there.
  if (isNativeApp()) {
    localStorage.setItem(TOKEN_KEY, token);
    sessionStorage.removeItem(TOKEN_KEY);
    return;
  }
  if (remember) {
    localStorage.setItem(TOKEN_KEY, token);
    sessionStorage.removeItem(TOKEN_KEY);
    return;
  }
  sessionStorage.setItem(TOKEN_KEY, token);
  localStorage.removeItem(TOKEN_KEY);
}

export function clearToken(): void {
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY);
}

export function roleToRedirectPath(role: BackendRole): string {
  switch (role) {
    case 'admin':
      return '/platform-admin-dashboard';
    case 'profesor':
      return '/teacher-dashboard';
    case 'parinte':
      return '/parent-dashboard';
    case 'elev':
      return '/student-dashboard';
    case 'secretariat':
      return '/secretariat-dashboard';
    default:
      return '/student-dashboard';
  }
}
